document.addEventListener('DOMContentLoaded', () => {
	const params = location.search;
	const searchParams = new URLSearchParams(params);

	for (const [key, value] of searchParams) {
		if (key.includes('utm')) {
			sessionStorage.setItem(key, JSON.stringify(value));
		}
	}
});
